import fromAnyToString from 'utils/converters/fromAnyToString';
import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';

// the following will be added by withRouter and/or <Route from React Router
export const fromPropsToHistoryPath = (props) => props?.history?.location?.pathname ?? '';
export const fromPropsToMatchedUrl = (props) => props?.match?.url ?? '';
export const fromPropsToMatchedPath = (props) => props?.match?.path ?? '';
export const fromPropsToMatchedParams = (props) => props?.match?.params ?? {};
export const fromPropsToPath = (props) => props?.location?.pathname ?? '';

export const fromPropsToQuery = (props) => {
  const search = props?.location?.search;
  return search ? fromEntriesToObject(new URLSearchParams(search).entries()) : {};
};

export const fromPropsToQueryString = (props) => {
  const search = props?.location?.search;
  return search ? new URLSearchParams(search).toString() : '';
};

export const fromPropsToPathSegments = (props) => {
  const path = fromAnyToString(fromPropsToPath(props));
  return path === '' ? [] : path.split('/');
};

// TODO: should delete this and use fromPathnameToIsWeek from src/bl/pathname.bl.js
export const fromPropsToIsWeek = (props) => fromAnyToString(fromPropsToPath(props)).includes('/week/');
